import { popupConstants } from "../_constants";
import { popupService } from "../_services";
import { alertActions } from "./";
import { history } from "../_helpers";

export const popupActions = {
  getDetail,
  saveClose
};

function getDetail() {
  return dispatch => {
    dispatch(request());

    popupService.getDetail().then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: popupConstants.DETAIL_REQUEST };
  }
  function success(detail) {
    return { type: popupConstants.DETAIL_SUCCESS, detail };
  }
  function failure(error) {
    return { type: popupConstants.DETAIL_FAILURE, error };
  }
}

function saveClose(id) {
  return dispatch => {
    dispatch(request());

    popupService.saveClose(id).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: popupConstants.SAVE_CLOSE_REQUEST };
  }
  function success(detail) {
    return { type: popupConstants.SAVE_CLOSE_SUCCESS, detail };
  }
  function failure(error) {
    return { type: popupConstants.SAVE_CLOSE_FAILURE, error };
  }
}
